import { baseSelectStyles } from 'components/PropertySelector/PropertySelector';
import RequiredFieldMarker from 'components/RequiredFieldMarker';
import React from 'react';
import Select, { OptionsType } from 'react-select';
import { OnChange } from 'types/OnChange';
import months from 'utils/months';

type Props = {
  onChangeMonth: OnChange;
  onChangeYear: OnChange;
  month: { value: number; label: string };
  year: { value: number; label: string };
  label: string;
  minDate?: string;
  maxDate?: string;
};

const DateSelector: React.FC<Props> = ({
  onChangeMonth,
  month,
  onChangeYear,
  year,
  label,
}: Props) => (
  <>
    <small>
      <label>{label}</label> <RequiredFieldMarker />
    </small>
    <div className="row">
      <div className="col" style={{ width: 100 }}>
        <Select
          menuPortalTarget={document.body}
          styles={baseSelectStyles}
          options={
            months.map((monthValue, index) => ({
              value: index,
              label: monthValue,
            })) as OptionsType<{ value: number; label: string }>
          }
          onChange={onChangeMonth}
          isClearable={false}
          defaultValue={month}
        />
      </div>
      <div className="col" style={{ width: 70 }}>
        <Select
          menuPortalTarget={document.body}
          styles={baseSelectStyles}
          options={
            [...Array(new Date().getFullYear() - 1970).keys()]
              .map((key) => key + 1 + 1970)
              .reverse()
              .map((yearValue) => ({
                value: yearValue,
                label: yearValue.toString(),
              })) as OptionsType<{ value: number; label: string }>
          }
          onChange={onChangeYear}
          isClearable={false}
          defaultValue={year}
        />
      </div>
    </div>
  </>
);

export default DateSelector;
